"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcInflationIndexedPriceChangeNotificationCard = class UcInflationIndexedPriceChangeNotificationCard extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    notification;
    onNotification(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("notification");
    }
    headerText;
    ux;
    dataMembers = ['headerText', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                headerText: this.$fn.gettext("Inflation indexed price change"),
                ux: null,
            },
        };
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_7751968922212722_showModal_2916_getActionArgs($event) {
        return {
            name: "InflationIndexedPriceChange",
            props: {
                id: this.notification.id,
            },
        };
    }
    async evh_7751968922212722_click(event, scope) {
        return await this.actions.evh_7751968922212722_click.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_2914 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_2913 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_2914,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_2913],
        });
        const act_7751968922212722_reloadComponentData_2918 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7751968922212722_close_2917 = new core_1.actions.EventHandlerImpl({
            action: act_7751968922212722_reloadComponentData_2918,
            event: "close",
            displayName: "reloadComponentData",
        });
        const act_7751968922212722_showModal_2916 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_7751968922212722_showModal_2916_getActionArgs,
            events: [evh_7751968922212722_close_2917],
        });
        const evh_7751968922212722_click_2915 = new core_1.actions.EventHandlerImpl({
            action: act_7751968922212722_showModal_2916,
            event: "click",
            displayName: "showModal",
        });
        const evh_7751968922212722_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7751968922212722_click_2915],
        });
        return {
            act_7315092382398562_reloadComponentData_2914,
            evh_7315092382398562_reload_2913,
            evh_7315092382398562_reload,
            act_7751968922212722_reloadComponentData_2918,
            evh_7751968922212722_close_2917,
            act_7751968922212722_showModal_2916,
            evh_7751968922212722_click_2915,
            evh_7751968922212722_click,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcInflationIndexedPriceChangeNotificationCard.prototype, "notification", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('notification'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInflationIndexedPriceChangeNotificationCard.prototype, "onNotification", null);
UcInflationIndexedPriceChangeNotificationCard = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcInflationIndexedPriceChangeNotificationCard);
exports.default = UcInflationIndexedPriceChangeNotificationCard;
vue_property_decorator_1.Vue.component("UcInflationIndexedPriceChangeNotificationCard", UcInflationIndexedPriceChangeNotificationCard);
